import axios from "axios";
import API_BASE_URI from '../../config/api.config'
import { guardAuthRequests } from "./authRequestGuard";

const API_BASE_PATH = '/jaaga/api'
const PAYMENT_PATH = '/api/payment'
const PROPERTY_BASE_PATH = '/api/property'

// `guardAuthRequests` blocks any `x-auth-token` request when signed out (except
// the public token-optional allow-list), so no auth API is ever hit logged out.
export const AxiosInstance = guardAuthRequests(axios.create({
   baseURL: window.location.origin + API_BASE_PATH
}))
export const AxiosPropertyInstance = guardAuthRequests(axios.create({
   baseURL: window.location.origin + PROPERTY_BASE_PATH
}))
export const AxiosPaymentInstance = guardAuthRequests(axios.create({
   baseURL: window.location.origin + PAYMENT_PATH
}))
